import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ElementsService} from '../../elements.service'
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'as-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],

})
export class PaginationComponent implements OnInit {

  @Input() data: any;
  @Input() url: string;
  @Input() minimalPagination: boolean
  @Input() hidePageSize = false;
  @Input() hidePagination = false;
  @Input() ajax: boolean = false;
  @Input() dataSubscriber;
  @Input() itemsPerPage = null;
  itemsToDisplay: number = 0
  pageSize: number;
  offset: number = 0;
  upper: number = 0;
  currentPage: number = 1;
  listSize: number = 0;
  pageCount: number;
  questions: Array<any>;
  filteredQuestions: Array<any>;
  resetToFirstPage: boolean = false;
  selectedValue;
  itemsLength: Array<any>;
  @Output() onChange = new EventEmitter();
  @Output() pageSizeOut = new EventEmitter();
  @Output() clicked = new EventEmitter();
  HTMLdata = [];
  RawHTMLdata: Array<any>[any];
  preloader = true;
  ajaxData: Array<any>[any];

  constructor(private http: HttpClient, private _elementService: ElementsService) {
  }

  ngOnInit() {

    if (!this.itemsPerPage) {
      this.pageSize = this.getState("pagesize") ?? 40;

    } else {
      this.pageSize = this.itemsPerPage;
    }

    if (this.dataSubscriber != undefined) {
      this.dataSubscriber.subscribe((c) => {

        this.data = c;
        this.run();
      })
    } else {
      this.run();
    }
  }

  setState(value) {
    if (!this.itemsPerPage) {
      localStorage.setItem("pagesize", value);
    }
  }

  getState(key) {
    let value = parseInt(localStorage.getItem(key));
    return (!isNaN(value)) ? value : null;
  }

  run() {

    if (this._elementService.getPaginationState() != undefined) {
      this.processPaginationState();
    } else {

      if (this.itemsToDisplay > 0) {

        this.pageSize = this.itemsToDisplay;

      } else {
        this.offset = this.pageSize
      }

      this.itemsLength = (this.itemsPerPage) ? [{value: this.itemsPerPage, label: this.itemsPerPage + ' items'}] : [
        {value: '10', label: '10 items'},
        {value: '20', label: '20 items'},
        {value: '40', label: '40 items'},
      ];


      if (this.url != undefined) {

      } else {
        this.RawHTMLdata = this.data;

        this.setTableData();

      }
    }
  }

  initDataUpdate(d) {
    //called externally

    this.RawHTMLdata = d;
    this.first();
  }

  setTableData() {
    this.first();
    this.preloader = false;
  }

  processPagination() {
    if (!this.ajax) {
      this.listSize = this.RawHTMLdata.length;
      this.updateListSize();
      this.calculatePageCount();
    }

  }

  updatePagination(upper, offset) {
    this.processPagination()

    if (this.ajax) {
      this.HTMLdata = this.RawHTMLdata;

    } else {
      this.HTMLdata = this.RawHTMLdata.slice(upper, (+offset))
    }
    this.onChange.emit(this.HTMLdata);

  }

  updateListSize() {
    this.HTMLdata = this.RawHTMLdata.slice(0, this.pageSize);
  }

  updatePagesize(value) {
    this.pageSize = +value;
    this.offset = this.pageSize;
    this.setState(this.pageSize);
    this.first();
  }

  calculatePageCount() {
    if (!this.ajax) {
      this.pageCount = Math.ceil((this.listSize / this.pageSize))
    }
  }

  next() {

    this.currentPage++;
    this.upper = this.offset;
    this.offset = (this.offset + this.pageSize);

    if (!this.ajax) {
      this.updatePagination(this.upper, this.offset)
    } else {
      this.processAjax();
    }
    this.clicked.emit(true);
  }

  prev() {

    this.currentPage--;
    this.upper = (this.upper - this.pageSize);
    this.offset = (this.offset - this.pageSize);

    if (!this.ajax) {
      this.updatePagination(this.upper, this.offset)
    } else {
      this.processAjax();
    }
    this.clicked.emit(true);
  }

  first(emmit?: boolean) {

    this.offset = this.pageSize;
    this.upper = 0;
    this.currentPage = 1;

    if (!this.ajax) {
      this.updatePagination(this.upper, this.offset)
      // this.processPagination();

      // this.onChange.emit(this.HTMLdata)
    } else {
      this.processAjax();
    }

    if (emmit) {
      this.clicked.emit(true);
    }
  }

  last() {

    this.offset = (this.pageCount * this.pageSize);
    this.upper = (this.offset - this.pageSize);
    this.currentPage = this.pageCount;

    if (!this.ajax) {
      this.updatePagination(this.upper, this.offset)

    } else {
      this.processAjax();
    }
    this.clicked.emit(true);
  }

  processAjax() {

    if (this.ajax) {
      this.preloader = true;

      let queryUrl = "?size=" + this.pageSize + "&offset=" + this.offset + "&upper=" + this.upper;

      try {
        this.http.get(this.url + queryUrl).subscribe((d) => {

          this.ajaxData = d["data"];
          this.RawHTMLdata = d["data"];
          this.updatePagination(this.upper, this.offset)
          this.pageCount = d["meta"].pages
          this.listSize = d["meta"].total

          // this.onChange.emit(d["data"])
          this.preloader = false;

          return true;
        })
      } catch (e) {
        console.log(e)
      }
    }
    return false;
  }

  setPaginationState() {
    let state = {
      currentPage: this.currentPage,
      listSize: this.listSize,
      offset: this.offset,
      pageSize: this.pageSize,
      pageCount: this.pageCount,
      HTMLdata: this.HTMLdata,
      RawHTMLdata: this.RawHTMLdata,
      upper: this.upper
    }

    this._elementService.setPaginationState(state)
  }

  processPaginationState() {

    let state = this._elementService.getPaginationState();
    //
    this.currentPage = state.currentPage;
    this.pageSize = state.pageSize;
    this.offset = state.offset;
    this.listSize = state.listSize
    this.HTMLdata = state.HTMLdata
    this.RawHTMLdata = state.RawHTMLdata
    this.upper = state.upper

    this.updatePagination(this.upper, this.offset)

  }

}
